import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { HOURS_IN_DAY, MINUTES_IN_HOUR } from './timeUtils';
class TimeRange {
  constructor(props) {
    _defineProperty(this, "start", void 0);
    _defineProperty(this, "end", void 0);
    const {
      start,
      end
    } = props;
    this.start = start;
    this.end = end;
  }
  isValid() {
    return this.end > this.start;
  }
  startsBefore(range) {
    return this.start < range.start;
  }
  isConcurrentWith(range) {
    return this.start === range.start;
  }
  isConterminalWith(range) {
    return this.end === range.end;
  }
  followedBy(range) {
    return this.end === range.start;
  }
  endsBefore(range) {
    return this.end < range.end;
  }
  precedes(range) {
    return this.end < range.start;
  }
}
export class MinutesRange extends TimeRange {
  getDayOfTheWeek() {
    return Math.floor(this.start / (HOURS_IN_DAY * MINUTES_IN_HOUR));
  }
}
//# sourceMappingURL=MinutesRange.js.map